module.exports = __webpack_public_path__ + "img/ss_blue-06.9f6ff832.jpg";